import { DANGER_700, GREY_100, RED_500, Symbols } from '@mnd-frontend/ui';
import type React from 'react';
import styled from 'styled-components';
import IconAndCaption from './IconAndCaption';

type Props = {
  caption: string;
  minHeight?: string;
};

const StyledContainer = styled.div<{ $minHeight?: string }>`
  background-color: ${GREY_100};
  box-sizing: border-box;
  border-radius: 0.25rem;
  width: 100%;
  height: 100%;
  position: relative;
  min-height: ${({ $minHeight }) => $minHeight ?? '12.5rem'};

  @keyframes popIt {
    0% {
      transform: translateY(0rem);
    }
    50% {
      transform: translateY(-0.12rem);
    }
    100% {
      transform: translateY(0rem);
    }
  }
  color: ${DANGER_700};

  svg {
    display: block;
    width: 3.125rem;
    height: 3.125rem;
    rect {
      animation: popIt 0.4s 1s cubic-bezier(0.42, 0.3, 0.65, 1.53);
    }
    path,
    rect {
      fill: ${DANGER_700};
    }
    path:first-child {
      fill: ${RED_500};
    }
  }
`;
const ErrorMessage: React.FC<Props> = ({ caption, minHeight }) => (
  <StyledContainer $minHeight={minHeight}>
    <IconAndCaption icon={<Symbols.AlertSign />} caption={caption} />
  </StyledContainer>
);

export default ErrorMessage;
